import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { CreationDetailFragment } from '../../../generated/graphql';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import _CompleteButton from './CompleteButton';

interface Props {
  creation: CreationDetailFragment;
  reload: () => void;
  className?: string;
}

const CompleteForm = ({ creation, reload, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>{creation ? <CompleteButton creation={creation} reload={reload} /> : null}</Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['1fr'],
    rows: ['auto', 'auto'],
    areas: [['headings'], ['reviewButton']],
  }),
  {
    textAlign: 'center',
  },
);

const CompleteButton = styled(_CompleteButton)(gridLayoutItem('reviewButton'));

export default CompleteForm;
